import { useCallback } from 'react';
import { DOCUMENT } from '@config/constants';
import { useAreDocumentsReady } from '@views/ProofDocuments/utils';
import {
  useDocumentForm,
  useFindDocumentByGroup,
} from '@views/ProofDocuments/hooks';
import { useGetDocumentsInfoQuery } from '../../graphql';

export const useController = () => {
  const {
    control,
    resetForm,
    clearField,
    onUploadError,
    onUploadCompleted: onUploadCompletedForm,
  } = useDocumentForm();

  const {
    data,
    loading: isLoading,
    refetch: refetchDocuments,
  } = useGetDocumentsInfoQuery({
    notifyOnNetworkStatusChange: true,
  });
  const { document: passportDocument } = useFindDocumentByGroup({
    data,
    klass: DOCUMENT.CLASS.ID_CARD,
    type: DOCUMENT.TYPE.PASSPORT,
    group: DOCUMENT.GROUPS.PASSPORT,
  });

  const neededDocuments = [passportDocument];

  const areDocumentsReady = useAreDocumentsReady({ neededDocuments });

  const onRemoveCompleted = useCallback(() => {
    resetForm();
    refetchDocuments();
  }, [
    resetForm,
    refetchDocuments,
  ]);

  const onUploadCompleted = useCallback(({ fieldName }) => {
    onUploadCompletedForm({ fieldName });
    refetchDocuments();
  }, [
    refetchDocuments,
    onUploadCompletedForm,
  ]);

  return {
    control,
    isLoading,
    clearField,
    onUploadError,
    passportDocument,
    areDocumentsReady,
    onRemoveCompleted,
    onUploadCompleted,
  };
};
